import { library } from '@fortawesome/fontawesome-svg-core';
import { faInfoCircle } from '@fortawesome/pro-duotone-svg-icons';
import { faCheck } from '@fortawesome/pro-duotone-svg-icons';
import { faEar } from '@fortawesome/pro-light-svg-icons';
import { faBoxAlt } from '@fortawesome/pro-light-svg-icons';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import {
    Redirect,
    Route,
    RouteComponentProps,
    Switch,
    withRouter,
} from 'react-router-dom';

import { ToastContainer, Zoom } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import './App.scss';
import withBucket from './components/authorization/with-bucket';
import withFeature from './components/authorization/with-feature';
import LoadingOverlay from './components/common/loading-overlay';
import eStoreHome from './components/e-store';
import ProductList from './components/e-store/product-list/product-list';
import ProductDetail from './components/e-store/product-details/product-detail';
import Cart from './components/e-store/cart/cart';
import ReceiversSelect from './components/e-store/product-list/receivers-select';
import ManageFeatureFlags from './components/my-account/admin/manage-feature-flags';
import ManagePromotions from './components/my-account/manage-promotions/manage-promotions';
import EditUser from './components/my-account/manage-users/edit-user';
import MyProfile from './components/my-account/my-profile';
import SoftwarePage from './components/my-account/software';
import ServiceRequestCenter from './components/my-account/service-requests/service-request-center';
import HelpCenter from './components/my-account/help-center/help-center';
import OrderDetails from './components/my-account/order-details/order-details';
import OrderHistory from './components/my-account/order-history/order-history';
import OrderCenter from './components/my-account/order-center/order-center-forms';
import StarkeyContacts from './components/my-account/starkey-contacts/starkey-contacts';
import PatientConsent from './components/my-account/patient-consent';
import OrderNotificationPreferences from './components/my-account/preferences/orders/order-notification-preferences';
import PreferencesHome from './components/my-account/preferences/preferences-home';
import RepairWarrantyPreferences from './components/my-account/preferences/repair-warranty/repair-warranty-preferences';
import ShippingPreferences from './components/my-account/preferences/shipping/shipping-preferences';
import accountSearch from './components/order-on-behalf-of/account-search';
import WorkshopRequest from './components/my-account/workshop-request/workshop-request';
import ShippingLabel from './components/my-account/print-shipping-label/shipping-label';
import WarrantyCenter from './components/my-account/warranty-center/warranty-center';
import OrderCertificates from './components/order-on-behalf-of/order-certificates/order-certificates';
import { Navigation } from './global-functions';
import { Buckets } from './models/buckets-enum';
import {
    CX_2019,
    ORDER_HISTORY,
    ORDER_NOTIFICATION_PREFERENCES,
    PRODUCT_DETAIL,
    REPAIR_WARRANTY_PREFERENCES,
    SHIPPING_PREFERENCES,
} from './models/constants';
import { loadSession } from './store/session/session-actions';
import { setIsBusy } from './store/api/api-status-action';
import { ISession } from './models/pro-sites';
import ScheduleUPSPickup from './components/my-account/schedule-pickup/schedule-pickup';
import AllTooltips from './components/common/AllTooltips';
import { RootState } from './store';
interface AppProps extends RouteComponentProps {
    loadSession: () => Promise<void>;
    setIsBusy: (isBusy: boolean, timeout: number) => Promise<void>;
    session: ISession | null;
    isBusy: boolean;
    spaPath: string;
}

library.add(faInfoCircle, faCheck, faEar, faBoxAlt);

const manageFeatureFlags = withBucket([Buckets.ManageCompanies])(
    ManageFeatureFlags
);

const estoreHomePage = withFeature([CX_2019])(eStoreHome);

const orderDetails = withFeature([ORDER_HISTORY])(OrderDetails);
const orderHistory = withFeature([ORDER_HISTORY])(OrderHistory);

const orderNotificationPreferences = withFeature([
    ORDER_NOTIFICATION_PREFERENCES,
])(OrderNotificationPreferences);
const receiversSelect = withFeature([CX_2019])(ReceiversSelect);
const productList = withFeature([CX_2019])(ProductList);
const productDetail = withFeature([PRODUCT_DETAIL])(ProductDetail);
const cart = withFeature([CX_2019])(Cart);

const repairWarrantyPreferences = withFeature([REPAIR_WARRANTY_PREFERENCES])(
    RepairWarrantyPreferences
);

const shippingPreferences = withFeature([SHIPPING_PREFERENCES])(
    ShippingPreferences
);

class App extends Component<AppProps> {
    componentDidMount(): void {
        window.rxApp = this;
    }

    refreshSession = () => {
        this.props.loadSession();
    };

    // useage: window.rxApp.navigate({url-path-only});
    navigate = (url: string) => {
        Navigation.smartNavigate(url, this.props.spaPath, this.props.history);
        this.props.setIsBusy(true, 100);
    };

    isBusy = (): boolean => {
        return this.props.isBusy;
    };

    render() {
        return (
            <LoadingOverlay active={this.props.isBusy}>
                <>
                    <AllTooltips />
                    {this.props.session &&
                        (this.props.session.isAccountThirdParty ? (
                            <Switch>
                                <Redirect
                                    from="/estore"
                                    to="/my-account/order-history"
                                />
                                <Route
                                    path="/my-account/order-history"
                                    component={orderHistory}
                                />
                                <Route
                                    path="/my-account/order-details"
                                    component={orderDetails}
                                />
                                <Redirect
                                    from="/*"
                                    exact={true}
                                    to="/my-account/order-history"
                                />
                            </Switch>
                        ) : (
                            <div className={'MIRACLEEAR'}>
                                {this.props.session.patientConsent === false ? (
                                    <Switch>
                                        <Route component={PatientConsent} />
                                    </Switch>
                                ) : (
                                    <Switch>
                                        <Redirect
                                            from="/"
                                            exact={true}
                                            to="/my-account/my-profile"
                                        />
                                        <Route
                                            path="/estore/receivers"
                                            component={receiversSelect}
                                        />

                                        <Route
                                            path="/estore/product-list"
                                            component={productList}
                                        />
                                        <Route
                                            path="/estore/product-detail/:productId"
                                            exact={true}
                                            component={productDetail}
                                        />

                                        <Route
                                            path="/estore/cart"
                                            component={cart}
                                        />
                                        <Route
                                            path="/estore"
                                            component={estoreHomePage}
                                        />
                                        <Route
                                            path="/my-account/starkey-admin/manage-feature-flags"
                                            component={manageFeatureFlags}
                                        />
                                        <Route
                                            path="/my-account/manage-promotions"
                                            component={ManagePromotions}
                                        />
                                        <Route
                                            path="/my-account/manage-users/user"
                                            component={EditUser}
                                        />
                                        <Route
                                            path="/my-account/my-profile"
                                            component={MyProfile}
                                        />
                                        <Route
                                            path="/my-account/software"
                                            component={SoftwarePage}
                                        />
                                        <Route
                                            path="/my-account/online-forms/service-request/color-exchange"
                                            component={ServiceRequestCenter}
                                        />
                                        <Route
                                            path="/my-account/order-history"
                                            component={orderHistory}
                                        />
                                        <Route
                                            path="/my-account/order-center/order-center-forms"
                                            component={OrderCenter}
                                        />
                                        <Route
                                            path="/my-account/starkey-contacts"
                                            component={StarkeyContacts}
                                        />
                                        <Route
                                            path="/my-account/order-details"
                                            component={orderDetails}
                                        />
                                        <Route
                                            path="/my-account/help-center"
                                            component={HelpCenter}
                                        />
                                        <Route
                                            path="/my-account/patient-consent"
                                            component={PatientConsent}
                                        />
                                        <Route
                                            path="/my-account/preferences/order-notification"
                                            component={
                                                orderNotificationPreferences
                                            }
                                        />
                                        <Route
                                            path="/my-account/preferences/repair-warranty"
                                            component={
                                                repairWarrantyPreferences
                                            }
                                        />
                                        <Route
                                            path="/my-account/preferences/shipping"
                                            component={shippingPreferences}
                                        />
                                        <Route
                                            path="/my-account/preferences"
                                            component={PreferencesHome}
                                        />
                                        <Route
                                            path="/accountSelection"
                                            exact={true}
                                            component={accountSearch}
                                        />
                                        <Route
                                            path="/orderonbehalfof"
                                            exact={true}
                                            component={accountSearch}
                                        />
                                        <Route
                                            path="/orderonbehalfof/order-certificates"
                                            exact={true}
                                            component={OrderCertificates}
                                        />
                                        <Route
                                            path="/my-account/online-forms/workshop-request"
                                            component={WorkshopRequest}
                                        />
                                        <Route
                                            path="/my-account/online-forms/shipping-labels"
                                            component={ShippingLabel}
                                        />
                                        <Route
                                            path="/my-account/online-forms/warranty-center"
                                            component={WarrantyCenter}
                                        />
                                        <Route
                                            path="/my-account/online-forms/schedule-pickup"
                                            component={ScheduleUPSPickup}
                                        />
                                        <Redirect
                                            from="/*"
                                            exact={true}
                                            to="/estore"
                                        />
                                    </Switch>
                                )}

                                <ToastContainer
                                    autoClose={false}
                                    hideProgressBar={true}
                                    transition={Zoom}
                                />
                            </div>
                        ))}
                </>
            </LoadingOverlay>
        );
    }
}

const mapStateToProps = (state: RootState) => {
    return {
        spaPath: state.spaPath,
        isBusy: state.apiCallsInProgress > 0,
        session: state.session ? state.session.data || null : null,
    };
};

const mapDispatchToProps = {
    loadSession,
    setIsBusy,
};

const appContainer = connect(mapStateToProps, mapDispatchToProps)(App);

export default withRouter(appContainer);
